module.exports = __webpack_public_path__ + "audio-f545f7425ecf.m4a";